<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let text: string;
  export let limit: number;
  export let expandable = true;
  export let renderHtml = false;
  export let isShowingMore = false;

  $: largerThanLimit = text.length > limit;
  $: canToggleText = expandable && largerThanLimit;
  $: truncatedText = text.slice(0, limit);

  if (renderHtml) {
    const firstTag = text.match(/<\/?[a-z][\s\S]*>/i);
    const firstTagIndex = firstTag?.index ?? Infinity;

    if (firstTagIndex < limit) {
      truncatedText = text.slice(0, firstTagIndex);
    }
  }

  const dispatch = createEventDispatcher<{ change: boolean }>();

  $: currentText = truncatedText;

  function toggleFullDescription() {
    if (isShowingMore) {
      currentText = truncatedText;
    } else {
      currentText = text;
    }

    isShowingMore = !isShowingMore;
    dispatch('change', isShowingMore);
  }
</script>

{#if canToggleText}
  {#if isShowingMore}
    {#if renderHtml}
      <!-- eslint-disable-next-line svelte/no-at-html-tags -->
      {@html currentText}
    {:else}
      {currentText}
    {/if}
    <slot />
    <button
      class="inline-link toggle-btn {$$slots.default ? 'mt-2' : ''}"
      on:click={toggleFullDescription}>&nbsp;less</button
    >
  {:else}
    {currentText}<button class="inline-link toggle-btn" on:click={toggleFullDescription}>
      ...more
    </button>
  {/if}
{:else}
  {currentText}{#if largerThanLimit}...{/if}
  <slot />
{/if}

<style>
  .toggle-btn {
    font-weight: inherit;
    font-size: inherit;
  }
</style>
